console.log('init: moment-js'); // eslint-disable-line no-console

const moment = require('moment');
require('moment-timezone');
require('@rangerrick/moment-javaformat');

module.exports = moment;